import { atomFamily, atomWithStorage } from "jotai/utils";
import { atom } from "jotai";
import type Player from "video.js/dist/types/player";

const playbackTimestampAtomFromRunId = atomFamily((runId: string) => atom(0));
const videoPlayerAtom = atom<Player | null>(null);

// Whether recording playback skips the inactive stretches between interactions.
// On by default; the user's choice persists across recordings.
const skipInactivityEnabledAtom = atomWithStorage(
  "recording.skipInactivity",
  true
);

export {
  playbackTimestampAtomFromRunId,
  videoPlayerAtom,
  skipInactivityEnabledAtom,
};
